// The "Discover what's new from RDrive" panel's CONTENT — only read when the dialog is
// rendered with `showMarketingPanel` (see ./setup.js for the mechanism, README "Marketing panel").
//
// Content, not mechanism, and deliberately NOT a prop: the panel advertises RDrive itself, so
// every dashboard shows the same four items, and the `height`/`crop` values are hand-tuned to
// these exact rdrive.io pages (whose height messages the dialog only accepts from rdrive.io).
// Changing the list is a package edit that every dashboard picks up. If a dashboard ever needs
// its own list, a `marketingItems` prop defaulting to this array is the non-breaking extension.
//
// Lifted from issue-analysis's WelcomeDialog.vue (IA `newWelcome` @ c103a1d). Per item:
//   id              stable id; carried by the `marketingItemOpen`/`marketingItemVisit` emits
//   titleKey        ./messages key of the item's title (card heading/alt text + panel header)
//   descriptionKey  ./messages key of the one-line description under the card
//   img             card thumbnail (316x200)                       — JS asset import, not CSS url()
//   titleImg        optional logo shown instead of the text title (all 50px tall)
//   url             the rdrive.io popup page, preloaded (hidden) in an iframe while the panel shows
//   targetUrl       optional: a navigation INSIDE the popup opens this page in a new tab
//   height          the iframe's viewport height (px). The pages use min-height:100vh, so they
//                   always fill it; tune it so the page's content fits.
//   crop            optional visible height (px) when the page leaves an empty strip at the
//                   bottom: the iframe keeps `height`, the dialog only shows the top `crop` px.
//                   To find it: open the item, then in DevTools run
//                     window.postMessage({ type: 'rdrive:iframe-height', height: <value> }, '*')
//                   until the white space / scrollbar is gone.
// Asset imports never fetch anything by themselves: an image is requested only when an
// <img src> renders it, i.e. only with the panel on.
import progressMonitoringImg from './assets/marketing/progress-monitoring.png';
import progressMonitoringTitleImg from './assets/marketing/progress-monitoring-title.png';
import bimIntegrationImg from './assets/marketing/bim-integration.png';
import bimIntegrationTitleImg from './assets/marketing/bim-integration-title.png';
import rkiveImg from './assets/marketing/rkive.png';
import rkiveTitleImg from './assets/marketing/rkive-title.png';
import goldenThreadImg from './assets/marketing/golden-thread.png';

export default [
  {
    id: 'progressMonitoring',
    titleKey: 'discoverProgressMonitoring',
    descriptionKey: 'discoverProgressMonitoringText',
    img: progressMonitoringImg,
    titleImg: progressMonitoringTitleImg,
    url: 'https://rdrive.io/en/popup-pm/',
    height: 542,
  },
  {
    id: 'bimIntegration',
    titleKey: 'discoverBimIntegration',
    descriptionKey: 'discoverBimIntegrationText',
    img: bimIntegrationImg,
    titleImg: bimIntegrationTitleImg,
    url: 'https://rdrive.io/en/popup-bim/',
    height: 480,
    crop: 480,
  },
  {
    id: 'rkive',
    titleKey: 'discoverRkive',
    descriptionKey: 'discoverRkiveText',
    img: rkiveImg,
    titleImg: rkiveTitleImg,
    url: 'https://rdrive.io/en/popup-rkive/',
    targetUrl: 'https://rdrive.io/en/products/rdrive-rkive/',
    height: 510,
  },
  {
    id: 'goldenThread',
    titleKey: 'discoverGoldenThread',
    descriptionKey: 'discoverGoldenThreadText',
    img: goldenThreadImg,
    url: 'https://rdrive.io/en/popup-golden-thread/',
    targetUrl: 'https://rdrive.io/en/golden-thread/',
    height: 450,
  },
];
